module.exports = __webpack_public_path__ + "img/bg_hillbo.fdba0e6f.jpg";